export default {
  getReports: {
    server: '/projects/{projectId}/reports',
    method: 'get',
  },

  deleteReport: {
    server: '/projects/{projectId}/reports/{reportId}',
    method: 'delete',
  },

  // 测点原始数据
  exportMeasuringPointData: {
    server: '/projects/{projectId}/reports/measuring-point-data',
    method: 'post',
  },

  // 导出测点报告
  exportMeasuringPointReport: {
    server: '/projects/{projectId}/reports/measuring-point-report',
    method: 'post',
  },

  // 导出项目报告
  exportProjectReport: {
    server: '/projects/{projectId}/reports/project-report',
    method: 'post',
  },

  // 远程生成项目报告
  exportProjectReportByLwj: {
    server: '/projects/{projectId}/reports/project-report-lwj',
    method: 'post',
  },

  exportDeviceResearch: {
    server: '/projects/{projectId}/reports/device-research',
    method: 'post',
  },
};
